import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, IconButton, Stack, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import EditIcon from "@mui/icons-material/Edit";
import {
  allQuotation,
  getQuotationDetailByMaster,
  getQuotationDetailByUser,
} from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { delteQuationService } from "../../lib/appUtliz/QuationsService";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import "./quation.css";
import { useOppurtunityId } from "../opportunity/OppurtunityContext";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { useLoading } from "../../context/LodingContext";
import PageLoading from "../../components/Loading/PageLoading";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableComponent from "../../components/GridTable/TableComponent";

const QuationsListTables = () => {
  const [quationData, setQuationData] = useState([]);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const [status, setStatus] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => { },
    onCancel: () => { },
  });
  const { setIdValue, idValue } = useOppurtunityId();
  const { circleLoading, setCirleLoading } = useLoading();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchContactData();
    setIdValue(null);
    // setStatus(!status);
  }, []);

  const fetchContactData = () => {
    setIsLoading(true);
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? getQuotationDetailByMaster
        : isUser.toLowerCase() == "employee"
          ? getQuotationDetailByUser
          : isUser.toLowerCase() == "superuser"
            ? allQuotation
            : "",

      { id: currentUser?.id }
    )
      .then((res) => {
        setQuationData(
          isUser.toLowerCase() == "manager"
            ? res.getQuotationDetailByMaster
            : isUser.toLowerCase() == "employee"
              ? res.getQuotationDetailByUser
              : isUser.toLowerCase() == "superuser"
                ? res.allQuotation
                : []
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleAddQuationForm = () => {
    navigate("/quotation/add-quotation");
  };
  
  const quationsListTable = {
    columns: [
      {
        label: "S No",
        field: "sno",
        name: "S No",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Quote Id",
        field: "qtnid",
        name: "Quote Id",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Customer",
        field: "customer",
        name: "Customer",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Quote Status",
        field: "quoteStatus",
        name: "Quote Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Approval Status",
        field: "approvelStatus",
        name: "Approvel Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Actions",
        field: "action",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: quationData

      .map((val, index) => ({
        sno: index + 1,
        id: val?.id,
        qtnid: val?.qtnid,
        opportunityid: val?.opportunity?.id,
        customer: val?.relatedName,
        quoteStatus: (
          <>
            <div>
              {val.quoteStatus}
              <div className="bar-mainbox">
                {val.quoteStatus.toLowerCase() == "draft" && (
                  <div style={{ width: "25%" }}></div>
                )}
                {val.quoteStatus.toLowerCase() == "win" && (
                  <div style={{ width: "65%" }}></div>
                )}
                {val.quoteStatus.toLowerCase() == "loss" && (
                  <div style={{ width: "100%", backgroundColor: "red" }}></div>
                )}
                {val.quoteStatus.toLowerCase() == "so converted" && (
                  <div style={{ width: "100%", background: "#f29c07" }}></div>
                )}
              </div>
            </div>
          </>
        ),
        approvelStatus: (
          <>
            <div >
              {val.approvelStatus}
              <div className="bar-mainbox">
                {val.approvelStatus.toLowerCase() == "draft" && (
                  <div style={{ width: "25%" }}></div>
                )}
                {val.approvelStatus.toLowerCase() == "waiting for approval" && (
                  <div style={{ width: "65%" }}></div>
                )}
                {val.approvelStatus.toLowerCase() == "approved" && (
                  <div style={{ width: "100%" }}></div>
                )}
                {val.approvelStatus.toLowerCase() == "rejected" && (
                  <div style={{ width: "100%", backgroundColor: "red" }}></div>
                )}
              </div>
            </div>
          </>
        ),
        createdBy: val.user.username,
        createdAt: val.createdAt ? val.createdAt.slice(0, 10) : "N/A",
        action: (
          <>
            {val.approvelStatus?.toLowerCase() == "draft" && (
              <div className="actionbutton">
                <Tooltip title="Edit">
                  <IconButton
                  onClick={() =>
                    navigate(`/quotation/edit-quotation?${val?.id}`, {
                      state: { type: "edit" },
                    })
                  }
                  className="iconsize"
                  fontSize="20px">
                  <EditIcon
                    
                  />
                  </IconButton>
                  
                </Tooltip>
                <Tooltip title="View">
                  <IconButton
                  onClick={() => navigate(`/quotation/view-quotation?${val?.id}`, { state: { type: "view" } })}
                  className="iconsize"
                  fontSize="20px">
                  <RemoveRedEyeIcon
                    
                  />
                  </IconButton>
                 
                </Tooltip>
                <Tooltip title="View Pdf">
                  <IconButton
                  onClick={() => navigate(`/quotation/${val?.id}`)}
                  className="iconsize"
                  fontSize="20px">
                  <PictureAsPdfIcon
                    
                  />
                  </IconButton>
                 
                </Tooltip>
              </div>
            )}

            {val.approvelStatus?.toLowerCase() == "waiting for approval" && (
              <div className="actionbutton">
                <Tooltip title="View">
                  <RemoveRedEyeIcon
                    onClick={() => navigate(`/quotation/view-quotation?${val?.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
                <Tooltip title="View Pdf">
                  <PictureAsPdfIcon
                    onClick={() => navigate(`/quotation/${val?.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
              </div>
            )}
            {val.approvelStatus?.toLowerCase() == "approved" && (
              <div className="actionbutton">
                <Tooltip title="View">
                  <RemoveRedEyeIcon
                    onClick={() => navigate(`/quotation/view-quotation?${val?.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
                <Tooltip title="View Pdf">
                  <PictureAsPdfIcon
                    onClick={() => navigate(`/quotation/${val?.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
                <Tooltip title="Change Win or Lost">
                  <CompareArrowsIcon
                    onClick={() => navigate(`/quotation/changestatus?${val.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
              </div>
            )}
            {val.approvelStatus?.toLowerCase() == "rejected" && (
              <div className="actionbutton">
                <Tooltip title="Edit">
                  <EditIcon
                    onClick={() =>
                      navigate(`/quotation/edit-quotation?${val?.id}`)
                    }
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
                <Tooltip title="View">
                  <RemoveRedEyeIcon
                    onClick={() => navigate(`/quotation/view-quotation?${val?.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                  {/* <Tooltip title="Edit">
                  <EditIcon className="iconsize" fontSize="20px" />
                </Tooltip> */}
                </Tooltip>
              </div>
            )}
            {val.quoteStatus?.toLowerCase() == "win " && (
              <div className="actionbutton">
                <Tooltip title="Converted to Sales Order">
                  <AutorenewIcon
                    onClick={() =>
                      navigate(`/quotation/convertsalesorder?${val.id}`)
                    }
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
              </div>
            )}
            {val.quoteStatus?.toLowerCase() == "loss  " && (
              <div className="actionbutton">
                {/* <Tooltip title="Edit">
                <EditIcon className="iconsize" fontSize="20px" />
              </Tooltip> */}
                <Tooltip title="View">
                  <RemoveRedEyeIcon
                    onClick={() => navigate(`/quotation/view-quotation?${val?.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
              </div>
            )}
            {val.quoteStatus?.toLowerCase() == "so converted   " && (
              <div className="actionbutton">
                <Tooltip title="View">
                  <RemoveRedEyeIcon
                    onClick={() => navigate(`/quotation/view-quotation?${val?.id}`)}
                    className="iconsize"
                    fontSize="20px"
                  />
                </Tooltip>
              </div>
            )}

            {/* <div style={{ width: "100%", height: "100%" }}>
            <div className="actionbutton">
              <Tooltip title="Converted to Sales Order">
                <AutorenewIcon
                  onClick={() =>
                    navigate(`/quotation/convertsalesorder?${val.id}`)
                  }
                  className="iconsize"
                  fontSize="20px"
                />
              </Tooltip>
              <Tooltip title="Change Win or Lost">
                <CompareArrowsIcon
                  onClick={() => navigate(`/quotation/changestatus?${val.id}`)}
                  className="iconsize"
                  fontSize="20px"
                />
              </Tooltip>
              <Tooltip title="Edit">
                <EditIcon className="iconsize" fontSize="20px" />
              </Tooltip>
              <Tooltip title="View">
                <RemoveRedEyeIcon
                  onClick={() => navigate(`/quotation/addquotation?${val?.id}`)}
                  className="iconsize"
                  fontSize="20px"
                />
              </Tooltip>
              <Tooltip title="Delte">
                <DeleteIcon
                  onClick={() => handledelteQuationData(val?.id)}
                  className="iconsize"
                  fontSize="20px"
                />
              </Tooltip>
            </div>
          </div> */}
          </>
        ),
      })),
  };

  const onLeadAndProscpectClick = (e) => {
    // setConfirmationDialog({
    //   open: true,
    //   title: "Confirmation",
    //   message: "Are you sure do you want to Delte your details.",
    //   showCancel: true,
    //   showConfirm: true,

    //   onConfirm: async () => {
    //     const status = await delteQuationService(e?.id);
    //     setStatus(status);
    //     setConfirmationDialog({
    //       ...confirmationDialog,
    //       open: false,
    //     });

    //     // status ? navigate("/quotation") : alert("err");
    //   },
    //   onCancel: () => {
    //     setConfirmationDialog({
    //       ...confirmationDialog,
    //       open: false,
    //     });
    //   },
    // });

    navigate(`/quotation/add-quotation?${e?.id}`);
  };
  const handleDwnldPdf = () => {};
  const handledelteQuationData = (id1) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delte your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        const status = await delteQuationService(id1);
        fetchContactData();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });

        status ? alert("delete ") : alert("err");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={quationsListTable.columns}
      rowsData={quationsListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Quoatation List"
      actions={false}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      // onEdit={onContactListClick}
      // onDelete={handledelteQuationData}
      // onView={onContactListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleAddQuationForm()} 
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Quotation List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddQuationForm()}
              >
                Add Quotation
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={quationsListTable.rows}
            columns={quationsListTable.columns}
          //  onRowClick={onLeadAndProscpectClick}
          // onRowClick={(data)=>handleRowClick(data)}
          />
        )}
        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
};

export default QuationsListTables;
